import { render, staticRenderFns } from "./Litem.vue?vue&type=template&id=c4400fd0&"
import script from "./Litem.vue?vue&type=script&lang=js&"
export * from "./Litem.vue?vue&type=script&lang=js&"
import style0 from "./Litem.vue?vue&type=style&index=0&id=c4400fd0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports